/**
 * tracking.js — PhoneSafe Repair Tracker
 * v3.2 — 6 fases Orderry + sanitizer de texto + datas uniformes + CTAs pos-reparacao
 */

// ── Estados do Orderry — fonte de verdade ────────────────────────────────────
// Replicado do portal B2B (orderry-mappers.ts).
// 7 grupos:  1=New/Aberto  2=In progress/Em reparação  3=Pending/Aguarda
//            4=Done/Reparado  5=Delivery/Em envio  6=Closed/Entregue
//            7=Dropped off/Não avançou
//
// As 6 fases visíveis no stepper são os grupos 1-6. Grupo 7 tem render proprio.

// Ordem VISUAL do stepper (nao corresponde 1:1 ao numero do grupo Orderry).
// "Aguarda" mostra-se ANTES de "Em reparação" porque do ponto de vista do
// cliente a espera (pecas, resposta, equipamento) e que precede a reparacao.
// Internamente o grupo Orderry continua a ser o id real.
var GROUP_PHASES = [
  { group: 1, label: 'Recebido'      },
  { group: 3, label: 'Aguarda'       },
  { group: 2, label: 'Em reparação'  },
  { group: 4, label: 'Reparado'      },
  { group: 5, label: 'Em envio'      },
  { group: 6, label: 'Entregue'      }
];

// Nome bruto Orderry -> grupo (1-7). 18 entradas conhecidas.
var ORDERRY_STATUS_GROUP = {
  'Aberto':                            1,
  'Em processo':                       2,
  'Orç. Aceite / Por Enc.':            3,
  'Peças Recebidas – Aguarda Rep.':    3,
  'Equipamento Recebido - Agu. Rep.':  3,
  'Pago / Por Encomendar':             3,
  'Aguarda Resposta do Cliente':       3,
  'Encomendado / Aguarda Peças':       3,
  'Encomendado / Aguarda Entrega':     3,
  'Aguarda Equipamento Cliente':       3,
  'Aguarda Pagamento':                 3,
  'Reparado':                          4,
  'Pronto Levantamento':               4,
  'Enviado Cliente':                   5,
  'Enviado Parceiro':                  5,
  'Entregue':                          6,
  'Orçamento Não Aceite':              7,
  'Sem Reparação':                     7
};

// Nome bruto Orderry -> label PT-PT amigável para o cliente.
var ORDERRY_STATUS_LABELS = {
  'Aberto':                            'Aberto',
  'Em processo':                       'Em reparação',
  'Orç. Aceite / Por Enc.':            'Orçamento aceite — por encomendar',
  'Peças Recebidas – Aguarda Rep.':    'Peças recebidas — aguarda reparação',
  'Equipamento Recebido - Agu. Rep.':  'Equipamento recebido — aguarda reparação',
  'Pago / Por Encomendar':             'Pago — por encomendar',
  'Aguarda Resposta do Cliente':       'Aguarda resposta do cliente',
  'Encomendado / Aguarda Peças':       'Encomendado — aguarda peças',
  'Encomendado / Aguarda Entrega':     'Encomendado — aguarda entrega',
  'Aguarda Equipamento Cliente':       'Aguarda equipamento do cliente',
  'Aguarda Pagamento':                 'Aguarda pagamento',
  'Reparado':                          'Reparado',
  'Pronto Levantamento':               'Pronto para levantamento',
  'Enviado Cliente':                   'Enviado para cliente',
  'Enviado Parceiro':                  'Enviado para parceiro',
  'Entregue':                          'Entregue',
  'Orçamento Não Aceite':              'Orçamento não aceite',
  'Sem Reparação':                     'Sem reparação'
};

// Fallback legacy: se a API enviar apenas status_key (formato antigo) e não
// o nome bruto, mapeamos para o grupo equivalente.
var STATUS_KEY_TO_GROUP = {
  pending:   1,
  repair:    2,
  wait:      3,
  ready:     4,
  done:      6,
  no_repair: 7
};

// Resolução central do estado de uma ordem.
// Devolve sempre { group, label, rawName, source } — onde source indica
// se vem do nome bruto Orderry ('name'), do status_key legacy ('key'),
// ou se foi inferido por defeito ('default').
function resolveStatus(order) {
  var rawName = (order && order.status ? String(order.status).trim() : '');
  if (rawName && ORDERRY_STATUS_GROUP[rawName]) {
    return {
      group:   ORDERRY_STATUS_GROUP[rawName],
      label:   ORDERRY_STATUS_LABELS[rawName] || rawName,
      rawName: rawName,
      source:  'name'
    };
  }
  var byKey = STATUS_KEY_TO_GROUP[order && order.status_key];
  if (byKey) {
    var phaseLabel = '';
    for (var k = 0; k < GROUP_PHASES.length; k++) {
      if (GROUP_PHASES[k].group === byKey) { phaseLabel = GROUP_PHASES[k].label; break; }
    }
    return {
      group:   byKey,
      label:   rawName || phaseLabel || '—',
      rawName: rawName,
      source:  'key'
    };
  }
  return { group: 1, label: rawName || 'Aberto', rawName: rawName, source: 'default' };
}

// Compat — mantido para zonas que ainda iteram STATUS_STEPS sem refactor.
var STATUS_STEPS = GROUP_PHASES.map(function(p) { return { key: 'g' + p.group, label: p.label }; });

// ── Sanitizador de texto do back-office ─────────────────────────────────────
// Aplica-se a campos vindos da API que historicamente vem sem acentos ou com
// termos antigos. Lista minima — ampliar conforme aparecerem casos.
var TEXT_FIXES = [
  [/\bReparacao\b/g, 'Reparação'],
  [/\breparacao\b/g, 'reparação'],
  [/\bReparacoes\b/g, 'Reparações'],
  [/\breparacoes\b/g, 'reparações'],
  [/\bTecnico\b/g, 'Técnico'],
  [/\btecnico\b/g, 'técnico'],
  [/\bTecnica\b/g, 'Técnica'],
  [/\bServico\b/g, 'Serviço'],
  [/\bservico\b/g, 'serviço'],
  [/\bServicos\b/g, 'Serviços'],
  [/\bservicos\b/g, 'serviços'],
  [/\bOrcamento\b/g, 'Orçamento'],
  [/\borcamento\b/g, 'orçamento'],
  [/\bPelicula\b/g, 'Película'],
  [/\bpelicula\b/g, 'película'],
  [/\bAltavoz\b/g, 'Altifalante'],
  [/\baltavoz\b/g, 'altifalante'],
  [/\bver possivel\b/gi, 'se possível']
];
function fixText(s) {
  if (s === null || s === undefined) return s;
  var out = String(s);
  for (var i = 0; i < TEXT_FIXES.length; i++) out = out.replace(TEXT_FIXES[i][0], TEXT_FIXES[i][1]);
  return out;
}

// Numero WhatsApp / loja — usado no CTA "Reportar problema"
var WHATSAPP_NUMBER  = '351968090070';
var GOOGLE_REVIEW_URL = 'https://g.page/r/CaHPmSUZCSZcEAE/review';
var PAGE_SIZE = 5;

// Classe CSS de badge por grupo (cores alinhadas com o portal B2B).
var GROUP_BADGE_CLASS = {
  1: 'rt-badge--g1',  // azul
  2: 'rt-badge--g2',  // turquesa (accent)
  3: 'rt-badge--g3',  // violeta
  4: 'rt-badge--g4',  // verde
  5: 'rt-badge--g5',  // âmbar
  6: 'rt-badge--g6',  // cinza
  7: 'rt-badge--g7'   // grená
};

// ── Utilitários ─────────────────────────────────────────────────────────────

function esc(str) {
  return String(str || '')
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}
function formatEuro(v) {
  var n = parseFloat(v);
  return isNaN(n) ? String(v) : n.toLocaleString('pt-PT',{style:'currency',currency:'EUR'});
}
function fmtDate(iso, opts) {
  if (!iso) return null;
  return new Date(iso).toLocaleDateString('pt-PT', opts || {day:'2-digit',month:'long',year:'numeric'});
}
function fmtDateShort(iso) {
  return fmtDate(iso, {day:'2-digit',month:'short',year:'numeric'});
}
function getInitials(name) {
  if (!name) return '?';
  var p = name.trim().split(/\s+/);
  return p.length >= 2
    ? (p[0][0] + p[p.length-1][0]).toUpperCase()
    : p[0].substring(0,2).toUpperCase();
}
function detailRow(label, value, valueClass) {
  return '<div class="rt-detail-row">' +
    '<span class="rt-detail-row__label">' + esc(label) + '</span>' +
    '<span class="rt-detail-row__value' + (valueClass ? ' ' + valueClass : '') + '">' + esc(value) + '</span>' +
  '</div>';
}

// Devolve o subtotal da reparação JÁ COM O DESCONTO APLICADO.
// Preferência: order.estimated (vem do C# já com discount subtraído).
// Fallback: soma de order_items menos order.discount — para ordens em curso
// onde o Orderry ainda não tem paid_cost/estimated_cost preenchidos.
function bestAmount(order) {
  if (!order) return null;
  var est = parseFloat(order.estimated);
  if (!isNaN(est) && est > 0) return est;
  if (order.order_items && order.order_items.length) {
    var gross    = order.order_items.reduce(function(s, i) { return s + (parseFloat(i.price) || 0); }, 0);
    var discount = parseFloat(order.discount) || 0;
    var net      = gross - discount;
    if (net > 0) return net;
  }
  return null;
}

// Verdadeiro quando a reparação esta pronta/enviada mas ainda não foi paga.
// Grupos 4 (Reparado/Pronto) e 5 (Em envio) entram em "pending payment" salvo
// is_paid=true. Para grupo 6 (Entregue) confiamos em is_paid/needs_payment.
function isPendingPayment(order, res) {
  if (!order) return false;
  if (order.is_paid === true) return false;
  if (order.needs_payment === true) return true;
  res = res || resolveStatus(order);
  return res.group === 4 || res.group === 5;
}

// Valor em dívida = subtotal menos o que já foi pago (nunca negativo).
// Usa bestAmount(): preferência ao estimated (paid_cost com desconto aplicado),
// fallback à soma de order_items quando o Orderry não tem subtotal definido.
// LIMITAÇÃO: o fallback aos itens é BRUTO (sem desconto). Para ordens fechadas,
// o paid_cost já vem com desconto aplicado e é sempre preferido.
function orderOwed(order) {
  if (!isPendingPayment(order)) return 0;
  var est  = bestAmount(order) || 0;
  var paid = parseFloat(order.paid_amount) || 0;
  return Math.max(0, est - paid);
}

// ── Componentes genéricos ────────────────────────────────────────────────────

/**
 * Secção nomeada dentro do card. Oculta-se automaticamente se content for vazio.
 */
function renderSection(title, content) {
  if (!content) return '';
  return '<div class="rt-section">' +
    '<p class="rt-section__title">' + esc(title) + '</p>' +
    content +
  '</div>';
}

// ── Componentes de card ──────────────────────────────────────────────────────

function renderSteps(order, res) {
  res = res || resolveStatus(order);

  // Grupo 7 (Dropped off) — render proprio com 2 nos: Receção -> Não avançou
  if (res.group === 7) {
    return '' +
      '<div class="rt-step" role="listitem">' +
        '<div class="rt-step__dot rt-step__dot--done">' +
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6L5 9L10 3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</div>' +
        '<div class="rt-step__label rt-step__label--done">Recebido<span class="rt-sr-only"> — concluída</span></div>' +
      '</div>' +
      '<div class="rt-step-line rt-step-line--dropped" aria-hidden="true"></div>' +
      '<div class="rt-step" role="listitem" aria-current="step">' +
        '<div class="rt-step__dot rt-step__dot--dropped">' +
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M3 3l6 6M9 3l-6 6" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '</div>' +
        '<div class="rt-step__label rt-step__label--dropped">Não avançou<span class="rt-sr-only"> — estado final</span></div>' +
      '</div>';
  }

  // Grupos 1-6 — fluxo normal. Usamos o INDICE do array (ordem visual),
  // nao o numero do grupo, porque "Aguarda" (3) aparece antes de "Em
  // reparação" (2) por opcao UX.
  var currentIdx = -1;
  for (var k = 0; k < GROUP_PHASES.length; k++) {
    if (GROUP_PHASES[k].group === res.group) { currentIdx = k; break; }
  }
  if (currentIdx === -1) currentIdx = 0;

  return GROUP_PHASES.map(function(phase, i) {
    var done   = i < currentIdx;
    var active = i === currentIdx;
    var dot = done
      ? '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6L5 9L10 3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : String(i + 1);
    var line = i < GROUP_PHASES.length - 1
      ? '<div class="rt-step-line' + (done ? ' rt-step-line--done' : '') + '" aria-hidden="true"></div>'
      : '';
    var ariaCurrent = active ? ' aria-current="step"' : '';
    var srState = done ? 'concluída' : active ? 'em curso' : 'pendente';
    return '<div class="rt-step" role="listitem"' + ariaCurrent + '>' +
      '<div class="rt-step__dot' + (done?' rt-step__dot--done':active?' rt-step__dot--active':'') + '">' + dot + '</div>' +
      '<div class="rt-step__label' + (done?' rt-step__label--done':active?' rt-step__label--active':'') + '">' + esc(phase.label) +
        '<span class="rt-sr-only"> — ' + srState + '</span>' +
      '</div>' +
    '</div>' + line;
  }).join('');
}

function renderWaitCallout(order, res) {
  res = res || resolveStatus(order);
  // Mostra o callout quando estamos no grupo 3 (Aguarda...) e ha detalhe
  // adicional do back-office. Tambem mostra-se para grupo 7 (Não avançou).
  if (res.group !== 3 && res.group !== 7) return '';
  var detail = fixText(order.status_detail) || '';
  if (!detail) return '';
  return '<div class="rt-callout">' +
    '<svg class="rt-callout__icon" width="14" height="14" viewBox="0 0 14 14" fill="none">' +
      '<circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.2"/>' +
      '<path d="M7 4.5v3.5M7 9.5v.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
    '</svg>' +
    esc(detail) +
  '</div>';
}

// Sublegenda diagnostica — mostra o nome bruto do Orderry sob o stepper.
// E o nosso melhor sinal de saude do mapping. Para grupo 6 (Entregue) e
// ja redundante (a fase 6 ja diz "Entregue"), por isso omitimos.
function renderRawStatus(order, res) {
  res = res || resolveStatus(order);
  if (res.group === 6 || res.group === 7) return '';
  var raw = res.rawName ? fixText(res.rawName) : '';
  if (!raw) return '';
  // Se o nome bruto e identico a fase generica, e redundante
  var phase = GROUP_PHASES[res.group - 1];
  if (phase && raw.toLowerCase() === phase.label.toLowerCase()) return '';
  return '<p class="rt-raw-status">' +
    '<span class="rt-raw-status__label">Estado atual:</span> ' +
    '<span class="rt-raw-status__value">' + esc(raw) + '</span>' +
  '</p>';
}

// CTAs pos-reparacao (design B) — so quando entregue (grupo 6).
// Hero: botao estilo Google "Avaliar no Google" centrado.
// Secundario: link cinza pequeno por baixo, abre WhatsApp pre-preenchido.
// Ambos sempre visiveis (nao gated por garantia) — o cliente pode sempre
// pedir ajuda independente do estado da garantia.
function renderPostRepairCTAs(order, res) {
  res = res || resolveStatus(order);
  if (res.group !== 6) return '';

  var orderRef = order.number || String(order.id || '');
  var waMsg = encodeURIComponent(
    'Olá, gostaria de falar sobre a minha reparação ' + orderRef + '.'
  );
  var waUrl = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + waMsg;

  return '' +
    '<div class="rt-cta-b">' +
      '<a class="rt-cta-b__primary" href="' + GOOGLE_REVIEW_URL + '" target="_blank" rel="noopener">' +
        '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">' +
          '<path fill="#F4B400" d="M9 1.7l2.2 4.5 5 .7-3.6 3.5.9 4.9L9 12.9l-4.5 2.4.9-4.9L1.8 6.9l5-.7L9 1.7z"/>' +
        '</svg>' +
        '<span>Avaliar no Google</span>' +
      '</a>' +
      '<a class="rt-cta-b__secondary" href="' + waUrl + '" target="_blank" rel="noopener">' +
        'Algum problema? Falar connosco &rarr;' +
      '</a>' +
    '</div>';
}

function renderWarranty(order, res) {
  res = res || resolveStatus(order);
  // "Em curso" = grupos 1-3 (ainda nao reparado): garantia so comeca apos entrega
  var inProgress = res.group >= 1 && res.group <= 3;

  if (inProgress) {
    return '<div class="rt-warranty rt-warranty--pending">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" style="flex-shrink:0">' +
        '<path d="M7 1.5L1.5 4v4c0 2.5 2.5 4.5 5.5 4.5S12.5 10.5 12.5 8V4L7 1.5z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>' +
      '</svg>' +
      'Garantia começa após entrega' +
    '</div>';
  }

  if (!order.warranty) {
    return '<div class="rt-warranty rt-warranty--none">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" style="flex-shrink:0;opacity:.4">' +
        '<path d="M7 1.5L1.5 4v4c0 2.5 2.5 4.5 5.5 4.5S12.5 10.5 12.5 8V4L7 1.5z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>' +
      '</svg>' +
      'Sem garantia' +
    '</div>';
  }

  var endDate = new Date(order.warranty); endDate.setHours(0,0,0,0);
  var today   = new Date();               today.setHours(0,0,0,0);
  var expired = today >= endDate;
  var daysLeft = Math.max(0, Math.ceil((endDate - today) / 86400000));

  var startDate;
  if (order.delivered_at) {
    startDate = new Date(order.delivered_at);
  } else if (order.due_date) {
    startDate = new Date(order.due_date);
  } else {
    startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 90);
  }
  startDate.setHours(0,0,0,0);

  var totalMs = Math.max(1, endDate - startDate);
  var elapsed = Math.max(0, today - startDate);
  var pct     = expired ? 100 : Math.min(99, Math.round(elapsed / totalMs * 100));

  var cls = expired ? ' rt-warranty--expired' : ' rt-warranty--active';
  return '<div class="rt-warranty' + cls + '">' +
    '<div class="rt-warranty__head">' +
      '<span class="rt-warranty__label">' + (expired ? 'Garantia expirada' : 'Garantia ativa') + '</span>' +
      (!expired ? '<span class="rt-warranty__days">' + daysLeft + ' dias restantes</span>' : '') +
    '</div>' +
    '<div class="rt-warranty__track">' +
      '<div class="rt-warranty__fill" style="width:' + pct + '%"></div>' +
    '</div>' +
    '<div class="rt-warranty__dates">' +
      '<span class="rt-warranty__date">' +
        '<span class="rt-warranty__date-label">Início</span>' +
        '<span class="rt-warranty__date-value">' + (fmtDateShort(startDate.toISOString()) || '-') + '</span>' +
      '</span>' +
      '<span class="rt-warranty__date rt-warranty__date--end">' +
        '<span class="rt-warranty__date-label">Fim</span>' +
        '<span class="rt-warranty__date-value">' + (fmtDateShort(order.warranty) || '-') + '</span>' +
      '</span>' +
    '</div>' +
  '</div>';
}

// ── Card principal ───────────────────────────────────────────────────────────

function renderCard(order, autoOpen) {
  var res         = resolveStatus(order);
  var badgeClass  = GROUP_BADGE_CLASS[res.group] || 'rt-badge--default';
  var ref         = order.number || String(order.id);
  var entryDate   = fmtDate(order.created_at, {day:'2-digit',month:'short',year:'numeric'}) || '-';
  var isPaidFlag  = (order.is_paid === true || order.is_paid === 1 || order.is_paid === '1');
  // Badge: label vem do resolveStatus (nome bonito PT-PT). Se entregue mas por
  // liquidar, mostramos "Pronto para levantamento" para nao confundir.
  var displayStatus;
  if (res.group === 6 && !isPaidFlag && isPendingPayment(order, res)) {
    displayStatus = 'Pronto para levantamento';
  } else {
    displayStatus = res.label || '—';
  }
  var liquidarChip  = '';

  // ── Cabeçalho (sempre visível) ─────────────────────────────────────────
  var summary =
    '<div class="rt-card__head" role="button" tabindex="0" aria-expanded="' + (autoOpen?'true':'false') + '">' +
      '<div class="rt-card__head-l">' +
        '<p class="rt-card__device">' + esc(order.device) + '</p>' +
        '<p class="rt-card__meta">Ordem ' + esc(ref) + ' &middot; ' + esc(entryDate) + '</p>' +
      '</div>' +
      '<div class="rt-card__head-r">' +
        '<div class="rt-card__badges">' +
          '<span class="rt-badge ' + badgeClass + '">' + esc(displayStatus) + '</span>' +
          liquidarChip +
        '</div>' +
        '<svg class="rt-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
          '<path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</div>' +
    '</div>';

  // ── Secção "Serviço" ────────────────────────────────────────────────────
  var orderItemsHtml = '';
  if (order.order_items && order.order_items.length) {
    var itemRows = order.order_items.map(function(s) {
      return '<li class="rt-service-item">' +
        '<span class="rt-service-item__name">' + esc(fixText(s.title)) + '</span>' +
      '</li>';
    }).join('');
    orderItemsHtml =
      '<p class="rt-section__sub">Serviço realizado</p>' +
      '<ul class="rt-service-list">' + itemRows + '</ul>';
  }

  // Técnico aparece sempre por último
  var tecnicoHtml = order.manager_name
    ? '<div class="rt-details">' + detailRow('Técnico', fixText(order.manager_name)) + '</div>'
    : '';

  var svcSection = renderSection('Serviço',
    '<div class="rt-details">' + detailRow('Problema', fixText(order.problem) || '-') + '</div>' +
    orderItemsHtml +
    tecnicoHtml
  );

  // ── Secção "Datas e valor" ──────────────────────────────────────────────
  // Formato unificado — sempre dd mmm yyyy (entrada e entrega/prazo)
  var datesRows = detailRow('Entrada', entryDate);

  if (res.group === 6 && order.delivered_at) {
    datesRows += detailRow('Entregue em', fmtDateShort(order.delivered_at) || '-');
  } else if (res.group !== 7 && order.due_date) {
    datesRows += detailRow('Prazo estimado', fmtDateShort(order.due_date) || '-');
  }

  // Valor — usa bestAmount() que tenta paid_amount → estimated → order_items
  var displayAmount = bestAmount(order);
  if (displayAmount !== null) {
    datesRows += detailRow('Valor', formatEuro(displayAmount));
  } else if (isPendingPayment(order, res)) {
    datesRows += detailRow('Valor', 'A orçamentar');
  }

  // Pagamento — "Pago", "Por liquidar", "Orçamento não aceite", ou nada (em curso)
  if (isPaidFlag) {
    datesRows +=
      '<div class="rt-detail-row">' +
        '<span class="rt-detail-row__label">Pagamento</span>' +
        '<span class="rt-detail-row__value rt-pay-ok">Pago</span>' +
      '</div>';
  } else if (res.group === 7) {
    datesRows +=
      '<div class="rt-detail-row">' +
        '<span class="rt-detail-row__label">Pagamento</span>' +
        '<span class="rt-detail-row__value rt-pay-refused">' + esc(res.label || 'Não aplicável') + '</span>' +
      '</div>';
  } else if (isPendingPayment(order, res)) {
    datesRows +=
      '<div class="rt-detail-row">' +
        '<span class="rt-detail-row__label">Pagamento</span>' +
        '<span class="rt-detail-row__value rt-pay-pending">Por liquidar</span>' +
      '</div>';
  }

  var datesSection = renderSection('Datas e valor',
    '<div class="rt-details">' + datesRows + '</div>'
  );

  // ── Corpo expansível ────────────────────────────────────────────────────
  var body =
    '<div class="rt-card__body">' +
      '<div class="rt-steps">' +
        '<div class="rt-steps__track" role="list" aria-label="Progresso da reparação">' + renderSteps(order, res) + '</div>' +
      '</div>' +
      renderWaitCallout(order, res) +
      svcSection +
      datesSection +
      renderWarranty(order, res) +
      renderPostRepairCTAs(order, res) +
    '</div>';

  return '<div class="rt-card' + (autoOpen ? ' rt-card--open' : '') + '">' + summary + body + '</div>';
}

// ── Stat cards (clicáveis — filtram a lista) ─────────────────────────────────

function renderStatCards(orders, activeFilter) {
  function g(o) { return resolveStatus(o).group; }
  var total    = orders.length;
  // "Reparadas" = ja reparada/pronta/em envio (grupos 4-5). Entregue (6) conta em Anteriores.
  var ready    = orders.filter(function(o) { var x = g(o); return x === 4 || x === 5; }).length;
  // "Em curso" = ainda em processamento (grupos 1-3)
  var active   = orders.filter(function(o) { var x = g(o); return x >= 1 && x <= 3; }).length;
  // "Recusadas" = grupo 7 (Dropped off)
  var refused  = orders.filter(function(o) { return g(o) === 7; }).length;

  function card(mod, filter, icon, value, label) {
    var sel = (filter === activeFilter) ? ' rt-stat--selected' : '';
    return '<div class="rt-stat rt-stat--' + mod + sel + '" data-filter="' + filter +
      '" role="button" tabindex="0" aria-pressed="' + (filter === activeFilter) + '">' +
      '<div class="rt-stat__icon">' + icon + '</div>' +
      '<p class="rt-stat__value">' + value + '</p>' +
      '<p class="rt-stat__label">' + esc(label) + '</p>' +
    '</div>';
  }

  var iTotal =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">' +
      '<rect x="1" y="1.5" width="12" height="2.5" rx="1.25" fill="currentColor"/>' +
      '<rect x="1" y="5.75" width="12" height="2.5" rx="1.25" fill="currentColor" opacity=".55"/>' +
      '<rect x="1" y="10" width="7.5" height="2.5" rx="1.25" fill="currentColor" opacity=".3"/>' +
    '</svg>';
  var iReady =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">' +
      '<path d="M2.5 7L5.5 10L11.5 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  var iActive =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">' +
      '<circle cx="7" cy="7" r="2.2" stroke="currentColor" stroke-width="1.2"/>' +
      '<path d="M7 1.5V3M7 11v1.5M1.5 7H3M11 7h1.5M3.2 3.2l1.1 1.1M9.7 9.7l1.1 1.1M3.2 10.8l1.1-1.1M9.7 4.3l1.1-1.1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
    '</svg>';
  var iRefused =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">' +
      '<circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.2"/>' +
      '<path d="M4.5 4.5l5 5M9.5 4.5l-5 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
    '</svg>';

  return '<div class="rt-stats">' +
    card('total',   'all',       iTotal,   total,   'Total') +
    card('ready',   'ready',     iReady,   ready,   'Reparadas') +
    card('active',  'active',    iActive,  active,  'Em Curso') +
    card('refused', 'no_repair', iRefused, refused, 'Recusadas') +
  '</div>';
}

// ── Saudação ─────────────────────────────────────────────────────────────────

function renderGreeting(orders) {
  var name = '';
  var tags = [];
  for (var i = 0; i < orders.length; i++) {
    if (orders[i].client_name && orders[i].client_name.trim()) {
      name = orders[i].client_name.trim();
      if (orders[i].client_tags && orders[i].client_tags.length) tags = orders[i].client_tags;
      break;
    }
  }
  var firstName = name ? name.split(/\s+/)[0] : '';
  var initials  = getInitials(name || '?');
  var count     = orders.length;
  var repLabel  = count === 1 ? '1 reparação' : (count + ' reparações');

  var tagsHtml = tags.length
    ? tags.map(function(t) { return '<span class="rt-client-tag">' + esc(t) + '</span>'; }).join('')
    : '';

  // Soma de valores em dívida
  var totalDebt = orders.reduce(function(acc, o) { return acc + orderOwed(o); }, 0);

  // Bloco de dívida — à ESQUERDA, estilo Arc VII
  var debtBlock =
    '<div class="rt-greeting__debt' + (totalDebt > 0 ? ' rt-greeting__debt--owed' : '') + '">' +
      '<span class="rt-debt__label">Em dívida</span>' +
      '<span class="rt-debt__amount">' +
        esc(formatEuro(totalDebt)) +
      '</span>' +
    '</div>';

  // Nome + tags + subtítulo — à DIREITA
  var nameBlock =
    '<div class="rt-greeting__right">' +
      '<div class="rt-greeting__name-row">' +
        '<div class="rt-avatar">' + esc(initials) + '</div>' +
        '<div class="rt-greeting__text">' +
          '<div class="rt-greeting__name-row-inner">' +
            '<p class="rt-greeting__name">Olá' + (firstName ? ', ' + esc(firstName) + '!' : '!') + '</p>' +
            tagsHtml +
          '</div>' +
          '<p class="rt-greeting__sub">' + esc(repLabel) + ' na Phone Safe</p>' +
        '</div>' +
      '</div>' +
    '</div>';

  return '<div class="rt-greeting">' + nameBlock + debtBlock + '</div>';
}

// ── Botão "Carregar mais" ────────────────────────────────────────────────────

function renderLoadMore(remaining, scope) {
  if (remaining <= 0) return '';
  var label = remaining === 1 ? 'Carregar mais 1 reparação' : 'Carregar mais ' + Math.min(remaining, PAGE_SIZE) + ' reparações';
  return '<button type="button" class="rt-load-more" data-scope="' + esc(scope) + '">' +
    '<span>' + label + '</span>' +
    '<span class="rt-load-more__count">' + remaining + ' restantes</span>' +
  '</button>';
}

// ── Agrupamento Em curso / Anteriores ─────────────────────────────────────────

function renderResults(orders, doneShown) {
  function g(o) { return resolveStatus(o).group; }
  // Em curso = grupos 1-5 (qualquer coisa que nao esta entregue ou rejeitada)
  var active = orders.filter(function(o) { var x = g(o); return x >= 1 && x <= 5; });
  // Anteriores = entregues (6) ou rejeitadas (7)
  var done   = orders.filter(function(o) { var x = g(o); return x === 6 || x === 7; });
  // Mais recente primeiro nas Anteriores
  done.sort(function(a, b) { return b.id - a.id; });

  var shown = Math.min(doneShown || PAGE_SIZE, done.length);
  var html  = '';

  if (active.length > 0) {
    html += '<p class="rt-section-label">Em curso</p>';
    // Primeira reparacao ativa abre automaticamente
    html += active.map(function(o, i) { return renderCard(o, i === 0); }).join('');
  }

  if (done.length > 0) {
    html += '<p class="rt-section-label">Anteriores</p>';
    html += done.slice(0, shown).map(function(o) { return renderCard(o, false); }).join('');
    html += renderLoadMore(done.length - shown, 'done');
  }

  return html;
}

function renderFiltered(orders, filter, shown) {
  function g(o) { return resolveStatus(o).group; }
  var filtered = orders.filter(function(o) {
    var x = g(o);
    if (filter === 'ready')     return x === 4 || x === 5;
    if (filter === 'active')    return x >= 1 && x <= 3;
    if (filter === 'no_repair') return x === 7;
    return true;
  }).slice().sort(function(a, b) { return b.id - a.id; });

  if (!filtered.length) {
    return '<p class="rt-filter-empty">Nenhuma reparacao nesta categoria.</p>';
  }

  var n = Math.min(shown || PAGE_SIZE, filtered.length);
  return filtered.slice(0, n).map(function(o) { return renderCard(o, false); }).join('') +
         renderLoadMore(filtered.length - n, 'filter');
}

// ── Estado vazio ──────────────────────────────────────────────────────────────

function emptyState() {
  var waMsg = encodeURIComponent(
    'Olá, não consigo localizar a minha reparação no tracker. Podem ajudar-me?'
  );
  var waUrl = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + waMsg;
  return '<div class="rt-empty">' +
    '<svg width="48" height="48" viewBox="0 0 48 48" fill="none">' +
      '<circle cx="24" cy="24" r="20" stroke="currentColor" stroke-width="2"/>' +
      '<path d="M24 14v12M24 30v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
    '</svg>' +
    '<strong>Nenhuma reparação encontrada</strong>' +
    '<p>Confirme se o número está correcto — pode ser o telemóvel associado à entrega ou o nº de ordem (ex: A5078).</p>' +
    '<a class="rt-empty__cta" href="' + waUrl + '" target="_blank" rel="noopener">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
        '<path d="M8 1.5C4.4 1.5 1.5 4.4 1.5 8c0 1.1.3 2.2.8 3.1L1.5 14.5l3.5-.8c.9.5 1.9.7 3 .7 3.6 0 6.5-2.9 6.5-6.5S11.6 1.5 8 1.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span>Falar connosco no WhatsApp</span>' +
    '</a>' +
  '</div>';
}

// ── Painel de diagnostico visual (so quando ?debug=1) ────────────────────────

function renderDebugPanel(rows) {
  var existing = document.getElementById('rt-debug-panel');
  if (existing) existing.remove();

  function colorForSource(s) {
    return s === 'name'    ? '#059669' :
           s === 'key'     ? '#D97706' :
                             '#DC2626';
  }
  function colorForGroup(g) {
    var colors = {1:'#1973E1',2:'#0A8A8A',3:'#6D3FB0',4:'#27AE60',5:'#B26A00',6:'#4B5563',7:'#9A3A3A'};
    return colors[g] || '#6B7280';
  }

  var header = '<tr style="background:#0F1117;color:#fff;">' +
    '<th style="padding:6px 10px;text-align:left;font-weight:700;">Ordem</th>' +
    '<th style="padding:6px 10px;text-align:left;font-weight:700;">status_key</th>' +
    '<th style="padding:6px 10px;text-align:left;font-weight:700;">status (raw)</th>' +
    '<th style="padding:6px 10px;text-align:center;font-weight:700;">grupo</th>' +
    '<th style="padding:6px 10px;text-align:left;font-weight:700;">label resolvida</th>' +
    '<th style="padding:6px 10px;text-align:center;font-weight:700;">source</th>' +
  '</tr>';

  var body = rows.map(function(r) {
    return '<tr style="border-bottom:1px solid #E8EAED;">' +
      '<td style="padding:6px 10px;font-weight:600;">' + esc(r.number || '-') + '</td>' +
      '<td style="padding:6px 10px;color:#6B7280;">' + esc(r.status_key || '-') + '</td>' +
      '<td style="padding:6px 10px;">' + esc(r.status_raw || '<em style="color:#DC2626;">— ausente —</em>') + '</td>' +
      '<td style="padding:6px 10px;text-align:center;"><span style="background:' + colorForGroup(r.group) + ';color:#fff;padding:2px 8px;border-radius:10px;font-weight:700;">' + r.group + '</span></td>' +
      '<td style="padding:6px 10px;">' + esc(r.label || '-') + '</td>' +
      '<td style="padding:6px 10px;text-align:center;"><span style="background:' + colorForSource(r.source) + ';color:#fff;padding:2px 8px;border-radius:10px;font-weight:700;text-transform:uppercase;font-size:.65rem;">' + r.source + '</span></td>' +
    '</tr>';
  }).join('');

  var legend = '<div style="padding:10px 14px;background:#F6F8FA;font-size:.72rem;color:#6B7280;line-height:1.6;">' +
    '<strong style="color:#0F1117;">Como ler:</strong> ' +
    '<span style="background:#059669;color:#fff;padding:1px 6px;border-radius:6px;">NAME</span> = backend envia nome bruto Orderry, mapping ótimo. ' +
    '<span style="background:#D97706;color:#fff;padding:1px 6px;border-radius:6px;">KEY</span> = só status_key legacy, labels genéricas. ' +
    '<span style="background:#DC2626;color:#fff;padding:1px 6px;border-radius:6px;">DEFAULT</span> = nem string nem key válidos.' +
  '</div>';

  var html = '<div id="rt-debug-panel" style="position:fixed;bottom:0;left:0;right:0;background:#fff;border-top:3px solid #0DBFBF;box-shadow:0 -8px 24px rgba(0,0,0,.15);z-index:9999;font-family:system-ui,sans-serif;max-height:60vh;overflow:auto;">' +
    '<div style="display:flex;justify-content:space-between;align-items:center;padding:10px 14px;background:#0DBFBF;color:#fff;">' +
      '<strong style="font-size:.78rem;letter-spacing:.05em;text-transform:uppercase;">🔍 Tracker Debug Panel · ' + rows.length + ' ordem(ns)</strong>' +
      '<button onclick="document.getElementById(\'rt-debug-panel\').remove()" style="background:rgba(255,255,255,.2);border:none;color:#fff;padding:4px 10px;border-radius:6px;font-weight:700;cursor:pointer;">Fechar ✕</button>' +
    '</div>' +
    '<table style="width:100%;border-collapse:collapse;font-size:.78rem;">' +
      '<thead>' + header + '</thead>' +
      '<tbody>' + body + '</tbody>' +
    '</table>' +
    legend +
  '</div>';

  document.body.insertAdjacentHTML('beforeend', html);
}

// ── Bootstrap ─────────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function() {
  var tracker  = document.getElementById('repair-tracker');
  if (!tracker) return;

  var WORKER_URL = tracker.dataset.apiUrl;
  var inputEl    = document.getElementById('rt-phone');
  var btn        = document.getElementById('rt-btn');
  var btnText    = btn.querySelector('.rt-btn__text');
  var btnLoader  = btn.querySelector('.rt-btn__loader');
  var errorEl    = document.getElementById('rt-error');
  var searchEl   = document.getElementById('rt-search');
  var resultsEl  = document.getElementById('rt-results');
  var cardsEl    = document.getElementById('rt-cards');
  var backBtn    = document.getElementById('rt-back');
  var debtAmount = document.getElementById('rt-debt-amount');

  // Ordens da pesquisa actual — necessário para os filtros
  var _allOrders    = [];
  var _activeFilter = 'all';
  var _doneShown    = PAGE_SIZE;
  var _filterShown  = PAGE_SIZE;

  inputEl.addEventListener('keydown', function(e) { if (e.key === 'Enter') doSearch(); });
  btn.addEventListener('click', doSearch);
  backBtn.addEventListener('click', function() {
    resultsEl.hidden  = true;
    searchEl.hidden   = false;
    inputEl.value     = '';
    errorEl.hidden    = true;
    _allOrders        = [];
    _activeFilter     = 'all';
    _doneShown        = PAGE_SIZE;
    _filterShown      = PAGE_SIZE;
    var debtBar = document.getElementById('rt-debt-bar');
    if (debtBar) debtBar.hidden = true;
    inputEl.focus();
  });

  // ── Event delegation — stat cards + toggles de card ──────────────────────
  cardsEl.addEventListener('click', function(e) {
    var more = e.target.closest('.rt-load-more');
    if (more) { loadMore(more.dataset.scope); return; }
    var stat = e.target.closest('.rt-stat[data-filter]');
    if (stat) { applyFilter(stat.dataset.filter); return; }
    var head = e.target.closest('.rt-card__head');
    if (head) toggleCard(head.closest('.rt-card'));
  });
  cardsEl.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var more = e.target.closest('.rt-load-more');
    if (more) { e.preventDefault(); loadMore(more.dataset.scope); return; }
    var stat = e.target.closest('.rt-stat[data-filter]');
    if (stat) { e.preventDefault(); applyFilter(stat.dataset.filter); return; }
    var head = e.target.closest('.rt-card__head');
    if (head) { e.preventDefault(); toggleCard(head.closest('.rt-card')); }
  });

  function loadMore(scope) {
    if (scope === 'done')   _doneShown   += PAGE_SIZE;
    if (scope === 'filter') _filterShown += PAGE_SIZE;
    rerenderOrders();
  }

  function rerenderOrders() {
    var ordersEl = document.getElementById('rt-orders');
    if (!ordersEl) return;
    ordersEl.innerHTML = (_activeFilter === 'all')
      ? renderResults(_allOrders, _doneShown)
      : renderFiltered(_allOrders, _activeFilter, _filterShown);
  }

  function toggleCard(card) {
    var isOpen = card.classList.toggle('rt-card--open');
    var head   = card.querySelector('.rt-card__head');
    if (head) head.setAttribute('aria-expanded', String(isOpen));
  }

  // ── Filtragem por stat card ───────────────────────────────────────────────
  function applyFilter(filter) {
    _activeFilter = filter;
    _filterShown  = PAGE_SIZE; // reseta paginação ao trocar de filtro

    var statsEl = cardsEl.querySelector('.rt-stats');
    if (statsEl) statsEl.outerHTML = renderStatCards(_allOrders, _activeFilter);

    rerenderOrders();
  }

  function doSearch() {
    var query = inputEl.value.trim();
    if (!query) { showError('Introduza o número de telemóvel ou o número de ordem.'); return; }

    var isOrderRef      = /^[A-Za-z]\d+$/.test(query);
    var isInternational = /^\+/.test(query) || /^00\d{8,}/.test(query);
    if (!isOrderRef && !isInternational) {
      if (query.replace(/\D/g,'').length < 9) {
        showError('Número inválido. Use 9+ dígitos, +447911... ou número de ordem (ex: A5078).');
        return;
      }
    }

    setLoading(true);
    errorEl.hidden = true;

    fetch(WORKER_URL, {
      method:  'POST',
      headers: {'Content-Type':'application/json'},
      body:    JSON.stringify({query: query})
    })
    .then(function(res) { return res.json().then(function(d) { return {ok:res.ok, data:d}; }); })
    .then(function(r) {
      if (!r.ok) { showError(fixText(r.data.error) || 'Erro ao pesquisar. Tente novamente.'); return; }
      var orders = r.data.orders || [];

      // Debug so quando explicitamente pedido via ?debug=1 no URL
      if (/[?&]debug=1\b/.test(window.location.search)) {
        var diag = orders.map(function(o) {
          var res = resolveStatus(o);
          return {
            number:     o.number,
            status_key: o.status_key,
            status_raw: o.status,
            group:      res.group,
            label:      res.label,
            source:     res.source
          };
        });
        console.log('[tracker] resposta API:', r);
        console.log('[tracker] orders.length:', orders.length);
        console.log('[tracker] primeira ordem:', orders[0]);
        console.table(diag);
        renderDebugPanel(diag);
      }

      try {
        if (!orders.length) {
          cardsEl.innerHTML = emptyState();
        } else {
          _allOrders    = orders;
          _activeFilter = 'all';
          _doneShown    = PAGE_SIZE;
          _filterShown  = PAGE_SIZE;
          cardsEl.innerHTML =
            renderGreeting(orders) +
            renderStatCards(orders, 'all') +
            '<div id="rt-orders">' + renderResults(orders, _doneShown) + '</div>';
        }
        searchEl.hidden  = true;
        resultsEl.hidden = false;
      } catch (renderErr) {
        console.error('[tracker] FALHA AO RENDERIZAR:', renderErr);
        console.error('[tracker] stack:', renderErr.stack);
        showError('Erro ao mostrar resultados — abra a consola (F12) e copie o erro.');
      }
    })
    .catch(function(err) {
      console.error('[repair-tracker]', err);
      showError('Erro de ligação. Verifique a sua internet e tente novamente.');
    })
    .finally(function() { setLoading(false); });
  }

  function setLoading(on) {
    btn.disabled     = on;
    btnText.hidden   = on;
    btnLoader.hidden = !on;
  }
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }
});
